import React, { memo } from 'react'
import styled from 'styled-components'
import { STYLES } from '../../static/style'
import { Centralized } from '../../components/Centralized'
import { SchoolResultsChart } from '../SchoolChart'

const StyledSchoolStatistics = styled.div`
  width: 100%;
  background-color: ${STYLES.COLOR_HEAVY_OUTER_SPACE_GRAY};
  padding: 1rem 0;
`

const SchoolResultsChartsContainer = styled(Centralized)`
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0;
  align-items: flex-start;
  justify-content: flex-start;
`

const ChartStyle = `
  padding: .5rem;
  box-sizing: border-box;
  background-color: ${STYLES.COLOR_WHITE};
  border-radius: ${STYLES.BORDER_RADIUS};
  margin: ${STYLES.GUTTER};
  min-width: 19rem;
`

const StyledSchoolResultsChart = styled(SchoolResultsChart)`
  ${ChartStyle}
`

interface ISchoolStatisticsProps {
  results?: object
}

const SchoolStatistics: React.FC<ISchoolStatisticsProps> = memo(
  ({ results }) => {
    const mediaStudyScoreChart = (
      <StyledSchoolResultsChart
        title="Median study score"
        fieldName="median_study_score"
        results={results}
      />
    )
    const over40StudyScoresPercentChart = (
      <StyledSchoolResultsChart
        title="40+ Study scores percent"
        fieldName="over_forty_study_scores_percent"
        results={results}
        color={STYLES.COLOR_BITTER_SWEET_RED}
      />
    )
    const medianAtarChart = (
      <StyledSchoolResultsChart
        title="Median Atar"
        fieldName="medianAtar"
        results={results}
      />
    )
    const atarOver65ScoreChart = (
      <StyledSchoolResultsChart
        title="Atar 65+ Score %"
        fieldName="over65AtarPercent"
        results={results}
        color={STYLES.COLOR_BITTER_SWEET_RED}
      />
    )
    const daChart = (
      <StyledSchoolResultsChart
        title="Distinguished achievers"
        fieldName="da"
        results={results}
      />
    )
    const daPercentChart = (
      <StyledSchoolResultsChart
        title="Distinguished achievers %"
        fieldName="percentage_of_distinguished_achievers"
        results={results}
        color={STYLES.COLOR_BITTER_SWEET_RED}
      />
    )
    const higherThanOp5PercentChart = (
      <StyledSchoolResultsChart
        title="OP 1-5%"
        fieldName="higherThanOp5Percent"
        results={results}
      />
    )
    const higherThanOp10PercentChart = (
      <StyledSchoolResultsChart
        title="OP 1-10%"
        fieldName="higherThanOp10Percent"
        results={results}
        color={STYLES.COLOR_BITTER_SWEET_RED}
      />
    )
    const noOfStudentWithAtarChart = (
      <StyledSchoolResultsChart
        title="# of Students with ATAR"
        fieldName="numberOfStudentsWithAtar"
        results={results}
        color={STYLES.COLOR_BITTER_SWEET_RED}
      />
    )
    const studentsWithAtarPercentChart = (
      <StyledSchoolResultsChart
        title="Students with ATAR %"
        fieldName="studentsWithAtarPercent"
        results={results}
        color={STYLES.COLOR_BITTER_SWEET_RED}
      />
    )

    if (
      !mediaStudyScoreChart &&
      !over40StudyScoresPercentChart &&
      !medianAtarChart &&
      !atarOver65ScoreChart &&
      !daChart &&
      !daPercentChart &&
      !higherThanOp5PercentChart &&
      !higherThanOp10PercentChart &&
      !noOfStudentWithAtarChart &&
      !studentsWithAtarPercentChart
    ) {
      return null
    }

    return (
      <StyledSchoolStatistics>
        <SchoolResultsChartsContainer>
          {/* VIC */}
          {mediaStudyScoreChart}
          {over40StudyScoresPercentChart}

          {/* ACT */}
          {medianAtarChart}
          {atarOver65ScoreChart}

          {/* NSW */}
          {daChart}
          {daPercentChart}

          {/* QLC */}
          {higherThanOp5PercentChart}
          {higherThanOp10PercentChart}

          {/* Western Australia */}
          {noOfStudentWithAtarChart}
          {studentsWithAtarPercentChart}
        </SchoolResultsChartsContainer>
      </StyledSchoolStatistics>
    )
  }
)

export { SchoolStatistics }
